import { auth } from "../firebase";

/**
 * El token de la sesión actual, para los endpoints que lo exigen.
 *
 * Espera a que Firebase restaure la sesión: la restaura desde IndexedDB de
 * forma asíncrona, así que en los primeros instantes `currentUser` puede ser
 * null aunque el usuario esté logueado. Sin esta espera, pedirle el token
 * apenas carga la página falla sin motivo.
 *
 * Es la misma solución que ya tenía TCADMIN en helpers/tcsocketApi.js.
 */
export function esperarUsuario(timeoutMs = 5000) {
  return new Promise((resolve, reject) => {
    if (auth.currentUser) return resolve(auth.currentUser);

    let resuelto = false;
    const cancelar = auth.onAuthStateChanged((user) => {
      if (resuelto || !user) return;
      resuelto = true;
      cancelar();
      resolve(user);
    });

    setTimeout(() => {
      if (resuelto) return;
      resuelto = true;
      try { cancelar(); } catch (e) { /* ya desuscripto */ }
      reject(new Error("SIN_SESION"));
    }, timeoutMs);
  });
}

export async function obtenerTokenDeSesion() {
  const user = await esperarUsuario();
  return await user.getIdToken();
}
